import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12Zm13.568-2.72c0-1.92-1.52-3.28-3.648-3.28C9.664 6 8.064 7.552 8 9.696l1.824.176c.032-1.2.848-2.048 2.032-2.048 1.056 0 1.792.672 1.792 1.648 0 .833-.57 1.267-1.203 1.748-.79.601-1.677 1.276-1.677 2.892h1.792c0-.78.57-1.227 1.215-1.731.835-.654 1.793-1.403 1.793-3.101Zm-5.088 7.024c0 .672.544 1.216 1.232 1.216.704 0 1.232-.544 1.232-1.216 0-.688-.528-1.216-1.232-1.216-.688 0-1.232.528-1.232 1.216Z",
      clipRule: "evenodd"
    }
  )
);
var SvgQuestionFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var QuestionFilled_default = SvgQuestionFilled;

export { QuestionFilled_default as default };
